import React from 'react';
import ExamSchedulerComponent from '../../modules/exam/ExamScheduler';

const ExamSchedulerPage = () => {
  return (
    <div className="container-fluid">
      <ExamSchedulerComponent />
    </div>
  );
};

export default ExamSchedulerPage;